<template>
  <section class="page-parts-evaluation">
    <div class="_wrapper">
      <div class="_container">
        <div class="_content">
          <template v-for="(evaluation, index) in list" :key="index">
            <div class="evaluation-item" :class="{ active: state.active == index }" @click="handleChange(index)">
              <span class="icon" :class="evaluation.icon">
                <AtomImage v-if="state.active === index" :src="`/images/common/white-${evaluation.icon}.svg`" alt="" />
                <AtomImage v-else :src="`/images/common/glay-${evaluation.icon}.svg`" alt="" />
              </span>
              <p class="evaluation-item-head">{{ evaluation.title }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="select-evaluation">
      <div class="_container">
        <template v-for="(evaluation, index) in list" :key="index">
          <div v-if="state.active == index" class="select-box">
            <p class="head">{{ evaluation.title }}</p>
            <p class="description">{{ evaluation.description }}</p>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Props = {
  list: PagePartsFragmentFragment["list"]
}

withDefaults(defineProps<Props>(), {
  list: () => [],
})

const state = reactive({
  active: 0,
})

const handleChange = (_index: number): void => {
  state.active = _index
}
</script>
